export default "__VITE_ASSET__CHQUTguK__"